<template>
  <transition name="fade">
    <div v-show="visible" class="confirm-mask">
      <div class="confirm-container relative">
        <i class="el-icon-close absolute pointer" style="right: 16px;top: 16px;font-size: 20px;color: #666666" @click="close"></i>
        <p class="title">大模型根据您的指令生成报告</p>
        <div class="disassembly-view flex items-center">
          <!-- 左侧 -->
          <div class="input-content flex-column items-center justify-between">
            <div class="current_radio relative">
              <div class="flex items-center justify-center type-radio">
                <template v-if="textObj.input && textObj.file">
                  <span :class="{ active: current === 'input' }" @click="current = 'input'">手动输入</span>
                  <i>|</i>
                  <span :class="{ active: current === 'file'}" @click="current = 'file'">文件解析</span>
                </template>
                <template v-if="textObj.input && !textObj.file">
                  <span :class="{ active: current === 'input' }" style="cursor: text">手动输入</span>
                </template>
                <template v-if="!textObj.input && textObj.file">
                  <span :class="{ active: current === 'file' }" style="cursor: text">文件解析</span>
                </template>
              </div>
            </div>
            <p class="input-file-render scroll-container" v-html="textObj[current]" v-if="current === 'input'"></p>
            <p class="input-file-render markdown-body scroll-container" v-html="textObj[current]" v-if="current === 'file'" />
          </div>
          <!-- 分割线 -->
          <div style="height:100%;width: 0;background: transparent;border-left: 1px dashed rgba(0,0,0,0.1)"></div>
          <!-- 右侧 -->
          <div class="input-content flex-column items-center justify-between">
            <div class="right-top" style="width: 100%;flex-shrink: 0">
              <div style="color: #0226E0;height: 18px;line-height: 18px;padding: 0 14px 6px" class="flex items-center">
                <img src="../../../assets/images/achievement/keywordContent.png" :height="13" :width="15" style="margin-right: 5px" alt=""/>
                基于大模型的技术需求拆解
              </div>
              <div class="field-content scroll-container" ref="descContent" style="max-height: 255px">
                {{ technology }}
              </div>
              <div class="keyword-input">
                <div style="font-size: 14px;height: 14px;padding: 10px 14px;color: #181F33">关键词：</div>
                <div class="keyword-box scroll-container" :style="{ maxHeight: keywordHeight + 'px' }">
                  <div
                    class="tag-item"
                    v-for="(tag,ind) in keywordTags"
                    :key="ind"
                    style="padding-right: 8px"
                  >
                    <span>{{ tag.tagName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'disassemblyDialog',
  props: {
    active: {
      type: String,
    },
    activeObj: {
      type: Object,
    },
    disassemblyData: {
      type: Array,
    },
  },
  data() {
    return {
      visible: false,
      current: '',
      textObj: {},

      keywordHeight: 0,

      technology: '',
      keywordTags: [],
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.textObj = this.activeObj;
          if (this.textObj.file && !this.textObj.input) {
            this.current = 'file';
          } else {
            this.current = 'input';
          }
          this.technology = this.disassemblyData[0]?.technology || '';
          let splitList = this.disassemblyData[0]?.keyword.split(' ');
          this.keywordTags = splitList && splitList?.length && splitList.map(item => {
            return { tagName: item }
          })

          this.$nextTick(() => {
            setTimeout(() => {
              let dom = this.$refs.descContent;
              if (dom) {
                console.log(dom.clientHeight);
                this.keywordHeight = 450 - (dom.clientHeight + 58);
              } else {
                this.keywordHeight = 135;
              }
            },200)
          })
        }
      },
      immediate: true,
      deep: true,
    }
  }
}
</script>

<style lang="less" scoped>
.confirm-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-container {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  min-width: 860px;
  max-width: 980px;
  width: 50%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.title {
  line-height: 20px;
  margin-bottom: 10px;
  text-align: center;
  color: #666666;
  font-size: 16px;
}

.markdown-body {
  text-align: justify;
  font-weight: 400 !important;
  color: #333333 !important;
  font-size: 14px !important;
  background: transparent !important;
  /deep/ table {
    overflow-x: auto;
    thead {
      th {
        min-width: 90px !important;
        text-align: center !important;
      }
    }
    tbody {
      td {
        text-align: center !important;
      }
    }
  }
}

.disassembly-view {
  width: 100%;
  height: 450px;
  border-radius: 10px;
  padding: 14px 0;
  background: #F0F6FE;


  .input-content {
    flex-shrink: 0;
    width: calc(50% - 8px);
    height: 100%;
    padding: 0 4px;
  }

  .scroll-container {
    position: relative;
    overflow: hidden;
    &:hover {
      overflow-y: auto;
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0);
      //background: red;
      border-radius: 4px;
      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
      transition: background 0.3s ease;
    }

    &:hover::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.02);
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(182, 183, 185, 0.2);
    }
  }

  .input-file-render {
    width: 100%;
    height: calc(100% - 30px);
    line-height: 22px;
    font-size: 16px;
    box-sizing: border-box;
    padding: 0 12px 0 14px;
    overflow-y: auto;
  }

  /deep/ .el-textarea {
    height: calc(100% - 30px);
  }

  .current_radio {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 18px;
    padding-bottom: 12px;
    color: rgba(0, 0, 0, 0.45);

    .el-icon-arrow-left {
      left: -2px;
      top: 1px;
      font-size: 15px;
      user-select: none;
      z-index: 9;
    }

    .type-radio {
      user-select: none;
      span {
        color: rgba(0, 0, 0, 0.5);
        font-size: 15px;
        cursor: pointer;
      }
      i {
        color: #333333;
        font-size: 13px;
        font-style: normal;
        padding: 0 10px;
      }
      .active {
        font-weight: 500;
        color: rgb(2, 38, 224);
      }
    }
  }
}

.field-content {
  box-sizing: border-box;
  padding: 0 12px 0 14px;
  font-weight: 400;
  font-size: 15px;
  line-height: 23px;
  color: rgba(0, 0, 0, 0.5);
  text-align: justify;
  overflow-y: auto !important;
}

.keyword-input {
  .keyword-box {
    width: 100%;
    display: flex;
    align-items: start;
    flex-wrap: wrap;
    height: auto;
    min-height: 58px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    padding: 0 12px 0 14px;
    /deep/ .el-tg {
      max-width: 400px;
      margin-right: 10px;
      color: #0226E0;
      border-color: #0226E0;
      padding: 0 8px;
      margin-bottom: 6px;
      background: transparent;
      .el-tag__close {
        color: #0226E0;
        &:hover {
          color: #fff;
          background: rgba(2, 38, 224, 0.7);
        }
      }
    }

    .tag-item {
      position: relative;
      max-width: calc(100% - 38px);
      flex-shrink: 0;
      color: rgba(2, 38, 224, 0.85);
      font-size: 13px;
      height: 24px;
      line-height: 24px;
      border: 1px solid #0226E0;
      padding: 1px 20px 1px 6px;
      margin-right: 8px;
      margin-bottom: 10px;
      border-radius: 4px;
      background: transparent;
      span {
        display: inline-block;
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;

        &::-webkit-scrollbar {
          width: 2px;
          height: 2px;
        }
      }
      /deep/ .el-input__inner {
        font-size: 13px;
        height: 24px;
        line-height: 24px;
        padding: 0 !important;
        border: none;
      }
      .el-icon-close {
        position: absolute;
        right: 3px;
        top: 0;
        vertical-align: top;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
        height: 26px;
        line-height: 26px;
        &:hover {
          color: #0226E0;
        }
      }
    }

    .button-new-tag {
      display: inline-block;
      /deep/ .el-button {
        height: 28px;
        line-height: 28px;
        padding: 0 !important;
        span {
          font-size: 14px;
          color: #0226E0;
          font-weight: 400;
          white-space: nowrap;
        }
      }
    }
    .input-new-tag {
      width: 90px;
      /deep/ .el-input__inner {
        padding: 0 4px !important;
        &:focus {
          border-color: #0226E0;
        }
        &::placeholder {
          color: #999;
          font-size: 12px;
        }
      }
    }
    /deep/ .el-button {
      padding: 0 6px;
    }
    .operation-btn {
      font-size: 12px;
      line-height: 28px;
      margin-left: 4px;
    }
  }
  /deep/ .el-textarea {
    padding-top: 10px;
    height: 81px !important;

    /deep/ .el-textarea__inner {
      font-size: 12px !important;
    }
  }
}

</style>